import $ from 'cash-dom';
import Settings from '../../../../components/Settings';
import UrlHelper from '../../../../components/UrlHelper';
import FiltersSessionStorage from '../FiltersSessionStorage';
import TabSingleField from '../fields/TabSingleField';
import Utils from '../../../../components/Utils';

/**
 * @mixin FiltersMixin
 */
const FiltersMixin = {
	_initFiltersHeightCalculating() {
		const $filters = $('.filters');

		//  we use this in css as var(--filters-half-height)
		const filtersHeight = $filters.outerHeight()

		if (filtersHeight) {
			document.documentElement.style.setProperty('--filters-half-height', (filtersHeight / 2) + "px");
		}

		const $fieldset = $filters.find('fieldset').not('.hidden');

		if ($fieldset.length) {
			document.documentElement.style.setProperty('--filters-dropdown-width', ($fieldset.outerWidth()) + "px");
		}
	},

	_initFirstVendorHeightCalculating() {
		this._calculateFirstVendorHeight();
		window.addEventListener('resize', this._calculateFirstVendorHeight, false);
	},

	_initFiltersSticky() {
		const $filters = $('.filters.stickable').not('.for-mobile');
		const $vendorsList = $filters.closest('.container').find('.vendors-list');
		const vendorList = $vendorsList.get(0);
		const filtersBlock = $filters.get(0);

		if (!filtersBlock) {
			return;
		}

		const handleScroll = () => {
			if (vendorList && vendorList.getBoundingClientRect().bottom <= 0) {
				$filters.removeClass('sticky');
			} else if (filtersBlock.getBoundingClientRect().top <= 24) {
				$filters.addClass('sticky');
			} else {
				$filters.removeClass('sticky');
			}
		};

		handleScroll();
		window.addEventListener('scroll', handleScroll);
	},

	_calculateFirstVendorHeight() {
		if (!this._$vendorsList) {
			return;
		}

		//  we use this in css as var(--first-vendor-half-height)
		const height = this._$vendorsList.first().outerHeight();

		if (height) {
			document.documentElement.style.setProperty('--first-vendor-half-height', (height / 2) + "px");
		}
	},

	_refillIndexes() {
		const self = this;

		this._hideOrShowEditorChoice();

		let index = 0;
		this._$vendorsList.each(function () {
			const $vendor = $(this);

			if ($vendor.hasClass('hidden')) {
				return;
			}

			const currentDataPos = $vendor.data('pos');
			const currentVendorIndex = currentDataPos + 1;

			const newVendorIndex = index + 1;
			const newDataPos = index;

			const currentClasses = $vendor.attr('class');
			const newClasses = currentClasses.replace('ppc-vendor-' + currentVendorIndex, 'ppc-vendor-' + newVendorIndex);
			$vendor.attr('class', newClasses);

			const $vendorListIndex = $vendor.find('.list-index, .list-index-container').find('.index-number').length
				? $vendor.find('.list-index, .list-index-container').find('.index-number')
				: $vendor.find('.list-index');

			$vendorListIndex.text(newVendorIndex);

			if ($vendor.find('.list-index-holder').length) {
				$vendor.find('.list-index-holder').text(newVendorIndex);
			}

			const oldPpcPostText = '_ppc_pos' + currentDataPos;
			const newPpcPostText = '_ppc_pos' + newDataPos;

			self._replaceTextInAllAttributes($vendor.get(0), oldPpcPostText, newPpcPostText);

			$vendor.find('[data-pos="' + currentDataPos + '"]').each(function () {
				self._replaceTextInAllAttributes(this, oldPpcPostText, newPpcPostText);
			});

			$vendor.data('pos', newDataPos);
			$vendor.find('[data-pos]').data('pos', newDataPos);

			// $vendor.data('btn-indexed', newVendorIndex);
			// $vendor.find('[data-btn-indexed]').data('btn-indexed', newVendorIndex);

			if (index === 0 && !this._dontRefillIndexesForEditorChoice) {
				// should be last thing to change
				const $editorChoice = $('.editor-choice');

				if (!$editorChoice.hasClass('not-changeable')) {
					$editorChoice.find('.ppc-single-vendor').replaceWith($vendor.clone());

					//apply changes to btn-names and apply Alooma tracking
					let editorChoiceVendorLinks = $editorChoice.find('a, [data-btn-name]');

					editorChoiceVendorLinks.each((i, v) => {
						let hrefAttrName = $(v).attr('data-href') ? 'data-href' : 'href',
							hrefAttrValue = $(v).attr(hrefAttrName),
							btnName = $(v).attr('data-btn-name');

						if (hrefAttrValue && btnName) {
							$(v).attr('data-alooma-re-apply', 1);

							if (btnName.indexOf('rankRow') === 0 || btnName.indexOf('AffBtn') === 0) {
								let newBtnName = btnName.indexOf('rankRow') === 0 ?
									btnName.replace('rankRow', 'topPickRankRow') :
									btnName.replace('AffBtn', 'topPickAffBtn');

								$(v).attr('data-btn-name', newBtnName);
								$(v).attr(hrefAttrName, hrefAttrValue.replace(btnName, newBtnName));

								if ($(v).attr('data-tooltip')) {
									$(v).attr('data-tooltip', newBtnName);
								}
							}
						}
					});

					Alooma.applyAloomaTracking();
				}
			}

			++index;
		});
	},

	/**
	 * @param {HTMLElement} element
	 * @param {string} searchValue
	 * @param {string} replaceValue
	 * @private
	 */
	_replaceTextInAllAttributes(element, searchValue, replaceValue) {
		for (const attribute of element.attributes) {
			if (typeof attribute.value === 'string') {
				attribute.value = attribute.value.replaceAll(searchValue, replaceValue);
			}
		}
	},

	/**
	 * Hides vendor that should be hidden by filter and returns vendors in visible order.
	 * @param {boolean} noFilters
	 * @param {Set<string>} vendorsToShow
	 * @param {{}} deeplinks
	 * @param {boolean} reorderVendors
	 * @param {BaseField|null} filterField
	 * @return {{}}
	 * @private
	 */
	_initAndGetVendorOrderData({noFilters, vendorsToShow, deeplinks = null, reorderVendors = false, filterField = null}) {
		const self = this;
		const vendorOrderData = {};
		const applyOriginalDeeplink = filterField && filterField.isWithDeeplinks();

		if (applyOriginalDeeplink) {
			Utils.setOriginalDeeplinkIfNeededForAllLinks()
		}

		let visibleItemsIndex = 0;

		if (reorderVendors) {
			this._reorederVendorsList(vendorsToShow);
		} else {
			this._setInitialVendorOrderIfNeeded();
		}

		self._$vendorsList.each(function (i) {
			const $singleVendor = $(this);
			const slug = $singleVendor.data('vendor-slug');

			if (self._isOverLimit(visibleItemsIndex) || (!noFilters && self._isOverFiltersLimit(visibleItemsIndex))) {
				$singleVendor.addClass('hidden');
				return;
			}

			let visible = (noFilters  && !self._excludedOnEmptyFilter(slug)) || vendorsToShow.has(slug);

			if ($singleVendor.hasClass('visibly-hidden')) {
				visible = $singleVendor.data('visibly-hidden-visible') !== undefined
					? $singleVendor.data('visibly-hidden-visible')
					: false;
			}

			if (($singleVendor.hasClass('visibly-hidden')) && filterField && filterField.isWithVisiblyHiddenSplit()
				&& vendorsToShow.has(slug)) {
				visible = filterField.getShowVisiblyHiddenVendor();
				$singleVendor.data('visibly-hidden-visible', visible);
			}

			if (visible) {
				$singleVendor.removeClass('hidden');

				if (i === 0) {
					self._showFirstVendorFeatures($singleVendor);
				} else {
					self._hideFirstVendorFeatures($singleVendor);
				}

				self._setFilteredDeeplinkIfNeeded($singleVendor, deeplinks);

				if (slug) {
					vendorOrderData[slug] = {
						position_id: visibleItemsIndex++,
						vendorTitle: Settings.CURREN_WEBSITE_ID === 'vpns-jp'
							? $singleVendor.data('vendor-slug')
							: $singleVendor.data('vendor-title'),
						vendor_id: $singleVendor.data('vendor-id'),
					};
				}
			} else {
				$singleVendor.addClass('hidden');
			}
		});

		return vendorOrderData;
	},

	/**
	 * @param {Set<string>} vendorsToShow
	 * @private
	 */
	_reorederVendorsList(vendorsToShow) {
		const $container = this._$vendorsList.parent();
		const detachedVendors = new Map();
		const detachedElements = new Map();

		const initialVendorsOrder = [];

		$container.children().each((i, element) => {
			const $element = $(element);

			if ($element.hasClass('ppc-single-vendor')) {
				initialVendorsOrder.push($element.data('vendor-slug'));
				detachedVendors.set($element.data('vendor-slug'), $element.detach());
			} else {
				detachedElements.set(i, $element.detach());
			}
		});

		if (!this._initialVendorsOrder) {
			this._initialVendorsOrder = initialVendorsOrder;
		}

		let lastAppenedIndex = this._appendDetachedSortItems({
			vendorsOrder: vendorsToShow,
			detachedVendors,
			detachedElements,
			$container,
		});

		this._appendDetachedTheRestItemsToTheEnd({lastAppenedIndex, detachedVendors, detachedElements, $container})

		this._resetVendorsList();
	},

	_appendDetachedSortItems({vendorsOrder, detachedVendors, detachedElements, $container}) {
		let index = 0;

		const appendDeleteAndIncrementFn = (detachedMap, key) => {
			$container.append(detachedMap.get(key));
			detachedMap.delete(key);
			++index;
		};

		for (const vendorSlug of vendorsOrder) {
			while (detachedElements.has(index)) {
				appendDeleteAndIncrementFn(detachedElements, index);
			}

			if (detachedVendors.has(vendorSlug)) {
				appendDeleteAndIncrementFn(detachedVendors, vendorSlug);
			}
		}

		return index;
	},

	_appendDetachedTheRestItemsToTheEnd({lastAppenedIndex, detachedVendors, detachedElements, $container}) {
		const addMissedElementsFn = () => {
			while (detachedElements.has(lastAppenedIndex)) {
				$container.append(detachedElements.get(lastAppenedIndex));
				++lastAppenedIndex;
			}
		};

		// add the rest of non-sorted vendors to the end of the list, if any left
		for (const $detachedVendor of detachedVendors.values()) {
			addMissedElementsFn();

			$container.append($detachedVendor);
			++lastAppenedIndex;
		}

		// in case we have some elements after the all vendors
		addMissedElementsFn();
	},

	_setInitialVendorOrderIfNeeded() {
		if (!Array.isArray(this._initialVendorsOrder)) {
			return;
		}

		const $container = this._$vendorsList.parent();
		const detachedVendors = new Map();
		const detachedElements = new Map();

		$container.children().each((i, element) => {
			const $element = $(element);

			if ($element.hasClass('ppc-single-vendor')) {
				detachedVendors.set($element.data('vendor-slug'), $element.detach());
			} else {
				detachedElements.set(i, $element.detach());
			}
		});

		this._appendDetachedSortItems({
			vendorsOrder: this._initialVendorsOrder,
			detachedVendors,
			detachedElements,
			$container,
		});

		this._resetVendorsList();
	},

	_isOverLimit(index) {
		if (this._limit === null) {
			return false;
		}

		return index >= this._limit;
	},

	_isOverFiltersLimit(index) {
		if (this._filtersLimit === null) {
			return false;
		}

		return index >= this._filtersLimit;
	},

	_excludedOnEmptyFilter(slug) {
		if (this._emptyFiltersExclusions.includes(slug)) {
			return true;
		}

		return false;
	},

	_showFirstVendorFeatures($singleVendor) {
		$singleVendor.find('.top-badge, .social-proof').removeClass('hidden');
		$singleVendor.find('.col-bullets .bullets-description, .col-bullets .apr-rates').addClass('first').find('i').removeClass('hidden');
		$singleVendor.find('.bubble-social-proof-holder').removeClass('hidden');
	},

	_hideFirstVendorFeatures($singleVendor) {
		$singleVendor.find('.top-badge, .social-proof').addClass('hidden');
		$singleVendor.find('.col-bullets .bullets-description, .col-bullets .apr-rates').removeClass('first').find('i').addClass('hidden');
		$singleVendor.find('.bubble-social-proof-holder').addClass('hidden');
	},

	_setFilteredDeeplinkIfNeeded($singleVendor, deeplinks) {
		if (!deeplinks) {
			return;
		}

		const vendorId = $singleVendor.data('vendor-id');
		const deeplinkFamily = deeplinks[vendorId] || null;

		if (!deeplinkFamily) {
			return;
		}

		Utils.setFilteredDeeplinkFamilyForAllLinksOfVendor(deeplinkFamily, vendorId);
	},

	_buildAndGetFiltersChangeData() {
		const filtersForChangeData = {};
		const allFilters = window.location.host.startsWith('jp.')
			? this._fields.getFieldsNameAndValue(true)
			: this._fields.getFieldsNameAndLabel(true);
		let index = 1;

		for (const [filterKey, filterField] of Object.entries(allFilters)) {
			filtersForChangeData['filter_' + index] = {
				question: filterKey,
				answer: filterField,
			};

			++index;
		}

		filtersForChangeData.filter_click_index = this._autoFilter ? 0 : this._filter_click_index;
		filtersForChangeData.filter_id = this._filter_id;

		return filtersForChangeData;
	},

	_initHandlers() {
		$(document).on('remove-vendors-and-trigger-filter', (e, {vendorsIdsToRemove}) => {
			this._$vendorsList.each((i, vendor) => {
				const $vendor = $(vendor);

				if (vendorsIdsToRemove.includes($vendor.data('vendor-id'))) {
					$vendor.remove();
				}
			})

			this._resetVendorsList();
			this._hideOrShowEditorChoice();

			this.setFilters(this.getActiveFilters(), false, true);
		});
	},

	_hideOrShowEditorChoice() {
		const $editorChoice = $('.editor-choice');

		if (this._$vendorsList.length) {
			$editorChoice.find('.ppc-single-vendor').removeClass('hidden')
		} else {
			$editorChoice.find('.ppc-single-vendor').addClass('hidden')
		}
	},

	_sendBiWithEmptyFilters() {
		const filters = this.getActiveFilters();
		const [filterName, currentFieldValue] = Object.keys(filters).length
			? Object.entries(filters)[0]
			: [null, null];

		let {vendorsToShow, noFilters} = this._fields.getVendorsToShowAndOtherData(this._exclusions);

		const firstFilter = this._fields.getFirst(filterName + '-tab')
		if (firstFilter instanceof TabSingleField && firstFilter.isLinkTheSameAsCurrentUrl) {
			noFilters = true;
		}

		const vendorOrderData = this._initAndGetVendorOrderData({noFilters, vendorsToShow});

		this._sendAloomaEvents(filterName, vendorOrderData, currentFieldValue);

		return vendorOrderData;
	},
};

export default FiltersMixin;
